import { Observable, OperatorFunction, BehaviorSubject } from 'rxjs';
import * as rx from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { Store, MemoizedSelector } from '@ngrx/store';

export { rx };

export const rxExcludeNullable = rx.filter(
  <T>(value: T): value is Exclude<T, null | undefined> => !!value,
);

export function filterEmpty<T>(): OperatorFunction<T | null | undefined, T> {
  return filter<T | null | undefined, T>(
    (value): value is T => value !== undefined && value !== null,
  );
}

export function getLastValue<T>(observable: Observable<T>) {
  let value: T;
  observable.pipe(rx.take(1)).subscribe(v => (value = v));

  // @ts-ignore
  return value;
}

export type SelectorType<T> = T extends MemoizedSelector<any, infer Result>
  ? Result
  : never;

export function behaviorSubjectFromSelector<T>(
  store$: Store,
  selector: MemoizedSelector<any, T>,
): BehaviorSubject<T> {
  const subject = new BehaviorSubject<T>(undefined as T);
  store$.select(selector).subscribe(subject);

  return subject;
}

export function behaviorSubjectFromObservable<T, D extends T | undefined = undefined>(
  source: Observable<T>,
  defaultValue?: D,
): BehaviorSubject<D extends undefined ? T | null : T> {
  const subject = new BehaviorSubject<T | null>(defaultValue ?? null);
  source.subscribe(subject);
  return subject as BehaviorSubject<D extends undefined ? T | null : T>;
}
